<template>
    <div class="form-field form-field__hidden" :class="rootClasses">
        <input type="hidden" v-bind="inputAttrs">
    </div>
</template>

<script>
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';


    export default {
        mixins: [
            formFieldAbstractMixin,
        ],
        inheritAttrs: false,
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
        },
    };
</script>
